import {
  SingleQuestionPropertiesLocationType,
  type SingleQuestionPropertiesStatus,
  useGetSingleQuestionPropertiesByStatusAndLocationQuery,
} from '@exam-management/graphql';
import { useQBankStructure } from '@exam-management/qbs-provider';
import { Box, Loading } from '@shared/components';

import { useQBankStructureDashBoardSearchParams } from '../../hooks';
import { QBankStructureDashBoardNavigationTabs } from '../qbank-structure-dashboard-navigation-tabs';
import { QBankStructureSingleQuestionDashBoardTable } from '../qbank-structure-single-question-dashboard-table';

export default function QBankStructureSingleQuestionDashBoard() {
  const { qBankStructureInformation } = useQBankStructure();
  const [{ status }] = useQBankStructureDashBoardSearchParams();
  const { data, loading } = useGetSingleQuestionPropertiesByStatusAndLocationQuery({
    variables: {
      input: {
        status: status as SingleQuestionPropertiesStatus,
        qBankStructureId: qBankStructureInformation.id,
        locationType: SingleQuestionPropertiesLocationType.QbankStructureLevelItem,
      },
    },
  });

  return (
    <Box
      sx={(theme) => ({
        width: '100%',
        border: `1px solid ${theme.palette.grey[300]}`,
        borderRadius: theme.shape.rounded(2),
        overflow: 'hidden',
      })}
    >
      <QBankStructureDashBoardNavigationTabs
        questionStatuses={['DRAFT', 'PUBLISHED', 'UNPUBLISHED', 'DISABLED']}
      />
      {loading ? (
        <Box sx={(theme) => ({ p: theme.spacing(6) })}>
          <Loading />
        </Box>
      ) : (
        <QBankStructureSingleQuestionDashBoardTable
          data={data?.qctGetSingleQuestionPropertiesByStatusAndLocation ?? []}
        />
      )}
    </Box>
  );
}
